<h2 mat-dialog-title>{{isEdit ? 'Edit' : 'Add'}} Service</h2>
<mat-dialog-content style="padding-top: 16px; overflow: visible;">
  <form [formGroup]="form" style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Product Type</mat-label>
      <mat-select formControlName="productTypeId">
        <mat-option *ngFor="let pt of productTypes" [value]="pt.id">{{pt.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Service Name</mat-label>
      <input matInput formControlName="serviceName">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Vendor Name</mat-label>
      <input matInput formControlName="vendorName" [matAutocomplete]="vendorAuto">
      <mat-autocomplete #vendorAuto="matAutocomplete" (optionSelected)="onVendorSelected($event.option.value)">
        <mat-option *ngFor="let v of filteredVendors | async" [value]="v.name">{{v.name}} <span *ngIf="v.id" style="color:#888">({{v.id}})</span></mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Sub Vendor Name</mat-label>
      <input matInput formControlName="subVendorName" [matAutocomplete]="subVendorAuto">
      <mat-autocomplete #subVendorAuto="matAutocomplete" (optionSelected)="onSubVendorSelected($event.option.value)">
        <mat-option *ngFor="let sv of filteredSubVendors | async" [value]="sv.name">{{sv.name}} <span *ngIf="sv.id" style="color:#888">({{sv.id}})</span></mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Cost</mat-label>
      <input matInput type="number" formControlName="cost">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Price</mat-label>
      <input matInput type="number" formControlName="price">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Agent Commission</mat-label>
      <input matInput type="number" formControlName="agentCommission">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Currency</mat-label>
      <input matInput formControlName="currencyCode">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Total Units</mat-label>
      <input matInput type="number" formControlName="totalUnits">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Service Start Date</mat-label>
      <input matInput [matDatepicker]="startPicker" formControlName="serviceStartDate">
      <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Service End Date</mat-label>
      <input matInput [matDatepicker]="endPicker" formControlName="serviceEndDate">
      <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
    <div style="grid-column: span 2;">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
        <mat-form-field appearance="outline" floatLabel="always" style="flex: 1;">
          <mat-label>Select Traveler</mat-label>
          <mat-select [formControl]="selectedTravelerControl">
            <mat-option *ngFor="let t of lookups?.travelers" [value]="t.name">{{t.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="addTraveler()" matTooltip="Add traveler" type="button" style="margin-bottom: 20px;">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
      <mat-chip-set *ngIf="travelersList.length > 0">
        <mat-chip *ngFor="let t of travelersList" (removed)="removeTraveler(t)">
          {{t}}
          <button matChipRemove><mat-icon>cancel</mat-icon></button>
        </mat-chip>
      </mat-chip-set>
    </div>
    <mat-form-field appearance="outline" floatLabel="always" style="grid-column: span 2;">
      <mat-label>Vendor Reference</mat-label>
      <input matInput formControlName="vendorReference">
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">{{isEdit ? 'Update' : 'Add'}}</button>
</mat-dialog-actions>
